import styles from 'styles/modules/CrosshatchLine.module.scss';

const CrosshatchLine = (props) => {
    return (
        <div {...props} className={[styles.line, props.className].join(' ')} />
    );
};

export default CrosshatchLine;
